module.exports = __webpack_public_path__ + "img/png6.c7867da2.png";